import { ReportItemsApiResponse } from '../types';
import { createSlice } from '@reduxjs/toolkit';

const initialState : ReportItemsApiResponse["data"] = {
	page: "1",
	maxPage: "1",
	reportItems: []
};

const reportItemsSlice = createSlice({
	name: 'reportItems',
	initialState: initialState,
	reducers: {
		setReportItemsData: (state, action) => action.payload,
		reset: (state, action) => initialState,
	},
});

export const { setReportItemsData, reset } = reportItemsSlice.actions;

export default reportItemsSlice.reducer;